import styles from './oInput.module.scss';

interface IProps extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  note?: string;
  invalid?: boolean;
  extension?: string;
}

const OInput = ({ note, invalid, extension, className, ...rest }: IProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.inputWrapper}>
        <input 
          className={`${styles.input} ${invalid ? styles.invalid : ''} ${extension ? styles.hasExtension : ''} ${className || ''}`} 
          {...rest} 
        />
        {extension && <span className={styles.extension}>{extension}</span>}
      </div>
      {note && <span className={styles.note}>{note}</span>}
    </div>
  );
};

export default OInput;
